import React from 'react'
import { connect } from 'react-redux'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import { POLICY_DETAIL_URL } from 'constants'

import { importExtraData } from 'scenes/VehicleDetail/components/Policy/actions'

import PolicyData from './PolicyData'
import AdditionalData from './AdditionalData'

import './styles.scss'


export class Policy extends BaseComponent {

  constructor() {
    super()
    this._bind('_refreshExtraData')
  }

  _fetchPolicyExtraData(policyId) {
    const params = this.props.match.params
    request(POLICY_DETAIL_URL(params.id, params.vehicleId, policyId))
    .then(({extra_data}) => {
      this.props.importExtraData(extra_data)
    })
    .catch(console.log)
  }

  componentDidMount() {
    this._fetchPolicyExtraData(this.props.policy.id)
  }

  _refreshExtraData() {
    this._fetchPolicyExtraData(this.props.policy.id)
  }

  render() {
    return (
      <div className="d-flex justify-content-between">
        <div id="PolicyData">
          <PolicyData
            userId={this.props.match.params.id}
            vehicleId={this.props.match.params.vehicleId}
            policyId={this.props.policy.id}
            refreshExtraData={this._refreshExtraData}
          />
        </div>
        <div id="AdditionalData">
          <AdditionalData
            userId={this.props.match.params.id}
            vehicleId={this.props.match.params.vehicleId}
            policyId={this.props.policy.id}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    vehicle: state.vehicleDetail.get('vehicle').toObject(),
    user: state.vehicleDetail.get('user').toObject(),
    policy: state.vehicleDetail.get('policy').toObject()
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    importExtraData: (extraData) => dispatch(importExtraData(extraData))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Policy)



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Policy/index.js